import Repository from '../../repositories/RepositoryFactory';
const ccmCarePlansRepository = Repository.get('ccmCarePlans');
export default {
	namespaced: true,
	state: {
		ccmCarePlansByPatientId: [],
		ccmCarePlansByCCMRecordId: [],
		ccmCarePlan: null,
	},
	mutations: {
		STORE_CCM_CARE_PLANS_BY_PATIENT_ID (state, payload) {
			state.ccmCarePlansByPatientId = payload;
		},
		STORE_CCM_CARE_PLANS_BY_CCM_RECORD_ID (state, payload) {
			state.ccmCarePlansByCCMRecordId = payload;
		},
		STORE_CCM_CARE_PLAN (state, payload) {
			state.ccmCarePlan = payload;
		},
		UPDATE_CCM_CARE_PLAN (state, payload) {
			state.ccmCarePlan = {
				...state.ccmCarePlan,
				...payload,
			};
		},
		UPDATE_CCM_CARE_PLAN_IN_PATIENT_LIST (state, payload) {
			const index = state.ccmCarePlansByPatientId.findIndex(
				(record) => record.id === payload.id,
			);
			if (index !== -1) {
				state.ccmCarePlansByPatientId.splice(index, 1, payload);
			}
		},
		ADD_CCM_CARE_PLAN_IN_PATIENT_LIST (state, payload) {
			state.ccmCarePlansByPatientId.unshift(payload);
		},
		REMOVE_CCM_CARE_PLAN (state, id) {
			state.ccmCarePlansByPatientId = state.ccmCarePlansByPatientId.filter(
				(record) => record.id !== id,
			);
		},
	},
	actions: {
		async getCCMCarePlansByPatientId ({ commit }, patientId) {
			const response = await ccmCarePlansRepository.getCCMCarePlansByPatientId(
				patientId,
			);
			commit('STORE_CCM_CARE_PLANS_BY_PATIENT_ID', response.data);
		},
		async getCCMCarePlansByCCMRecordId ({ commit }, ccmRecordId) {
			const response =
				await ccmCarePlansRepository.getCCMCarePlansByCCMRecordId(ccmRecordId);

			commit('STORE_CCM_CARE_PLANS_BY_CCM_RECORD_ID', response.data);
		},
		async getCCMCarePlan ({ commit }, id) {
			const response = await ccmCarePlansRepository.getCCMCarePlan(id);
			commit('STORE_CCM_CARE_PLAN', response.data);
		},
		async addCCMCarePlan ({ commit }, body) {
			const response = await ccmCarePlansRepository.addCCMCarePlan(body);
			commit('ADD_CCM_CARE_PLAN_IN_PATIENT_LIST', response.data);
			return response;
		},
		async updateCCMCarePlan ({ commit }, request) {
			const response = await ccmCarePlansRepository.updateCCMCarePlan(
				request.id,
				request.body,
			);
			commit('UPDATE_CCM_CARE_PLAN_IN_PATIENT_LIST', response.data);
			return response;
		},
		async deleteCCMCarePlan ({ commit }, id) {
			commit('REMOVE_CCM_CARE_PLAN', id);
			return await ccmCarePlansRepository.deleteCCMCarePlan(id);
		},
	},
};
